<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">

        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Invoices</h3>
            </div>
            <div class="col-auto text-right">
              <a hidden v-if="showDeleteAllInvoicesButton" @click="syncInvoices()" class="btn btn-primary"><i
                class="fa fa-cloud-download-alt"></i> Sync</a>
              <a hidden v-if="showDeleteAllInvoicesButton" @click="pushInvoices()" class="btn btn-primary"><i
                class="fa fa-cloud-upload-alt"></i> Push</a>
              <a hidden v-if="showDeleteAllInvoicesButton" @click="deleteInvoices()" class="btn btn-danger"><i
                class="fa fa-trash"></i> Delete All</a>
              <a hidden @click="goToCreateBulkInvoice()" class="btn btn-primary"><i class="fa fa-plus"></i> Bulk Invoice</a>
              <a hidden @click="goToCreateInvoice()" class="btn btn-primary"><i class="fa fa-plus"></i> New Invoice</a>
              <div v-if="!isCustomerContact" class="btn-group">
                <button v-if="showButtonFor('INVOICE_CREATE')" :title="buttonTooltip('INVOICE_CREATE')"
                        :disabled="isDisabledFor('INVOICE_CREATE')" type="button" class="btn btn-primary"
                        @click="goToCreateInvoice()">
                  <i class="fa fa-plus mr-1"></i> New Invoice
                </button>
                <button v-if="showButtonFor('INVOICE_CREATE')" :title="buttonTooltip('INVOICE_CREATE')"
                        :disabled="isDisabledFor('INVOICE_CREATE')" type="button"
                        class="btn  btn-outline-primary dropdown-toggle dropdown-toggle-split " data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu mr-5 bulk">
                  <button v-if="showButtonFor('INVOICE_CREATE')" :title="buttonTooltip('INVOICE_CREATE')"
                          :disabled="isDisabledFor('INVOICE_CREATE')" class="dropdown-item"
                          @click="goToCreateBulkInvoice()">Bulk Invoice
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <GenericTabs
          :activeTab="activeTab"
          :tabs="invoiceTabs"
          :modules="modules"
          :permissions="permissions"
          :locale="$i18n.locale"
        />

        <div class="row" ref="formContainer">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row" v-if="permissions && permissions['INVOICES_SEARCH']">
                  <div class="col-sm-12 col-md-0">
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <select
                          class="input-group-text form-control bg-primary"
                          v-model="selectedSearchFilterId"
                          @change="changeSearchFilter"
                          :required="true">
                          <option
                            v-for="searchFilter in searchFilters"
                            :key="searchFilter.key"
                            :value="searchFilter.key"
                            :name="searchFilter.key"
                            :selected="searchFilter.key === selectedSearchFilterId">
                            {{ $t(searchFilter.value) }}
                          </option>
                        </select>
                      </div>
                      <input class="form-control" type="text" v-model="searchValue"
                             @keyup="fetchInvoices" placeholder="Search invoices...">
                    </div>
                  </div>
                </div>
                <hr/>
                <div class="table-responsive">

                  <invoice-list-table v-if="invoices"
                                      :invoices="invoices"></invoice-list-table>

                  <table id="tblInvoices" class="table table-hover table-center mb-0" hidden>
                    <thead style="background-color: ghostwhite">
                    <tr>
                      <!--                      <th class="text-left">Invoice Number</th>-->
                      <!--                      <th class="text-center">Customer ID</th>-->
                      <th class="text-left">Number</th>
                      <th class="text-left">Type</th>
                      <th class="text-left">Customer</th>
                      <!--                      <th class="text-left">Currency</th>-->
                      <th class="text-left">Invoice Date</th>
                      <!--                      <th class="text-center">Invoicing Date</th>-->
                      <!--                      <th class="text-center">Due Date</th>-->
                      <th class="text-left">Total</th>
                      <th class="text-left">Balance</th>
                      <th class="text-left">Rate</th>
                      <th class="text-left">Date Created</th>
                      <th class="text-left">Status</th>
                      <!--                      <th class="text-left"  v-if="showSyncStatus">Sync Status</th>-->
                      <th class="text-right">Action</th>
                    </tr>
                    </thead>
                    <tbody v-if="invoices.length">
                    <tr v-for="invoice in invoices" :key="invoice.id">
                      <!--                      <td>-->
                      <!--                        <h2 class="table-avatar">-->
                      <!--                          <a href="#" class="avatar avatar-sm mr-2">-->
                      <!--                            <img class="avatar-img rounded-circle" src="@/assets/img/customer/invoice-01.jpg"-->
                      <!--                                 alt="Invoice Image">-->
                      <!--                          </a>-->
                      <!--                          <a href="#">{{ invoice.profile ? invoice.profile.firstName : ""}} {{ invoice.profile ? invoice.profile.lastName : ""}}</a>-->
                      <!--                        </h2>-->
                      <!--                      </td>-->
                      <td class="text-left">{{ invoice.invoiceNumber || '-' }}</td>
                      <td class="text-left">
                        <span v-if="invoice.type === 'INVOICE'" class="badge badge-primary">Invoice</span>
                        <span v-else-if="invoice.type === 'CREDIT_NOTE'" class="badge badge-success">Credit Note</span>
                        <span v-else-if="invoice.type === 'DEBIT_NOTE'" class="badge badge-warning">Debit Note</span>
                        <span v-else class="badge badge-secondary">{{ invoice.type || '-' }}</span>
                      </td>
                      <!--                      <td class="text-center">{{ invoice.customer && invoice.customer.customerId || '-'}}</td>-->
                      <!--                      <td class="text-left">{{ invoice.invoiceNumber }}</td>-->
                      <td class="text-left">
                        {{
                          invoice.customer && invoice.customer.name || invoice.customer && invoice.customer.customerId || 'Walk-in'
                        }}
                      </td>
                      <!--                      <td class="text-left">{{ invoice.currency }}</td>-->
                      <td class="text-left">{{ invoice.date ? utcDateToLocal(invoice.date) : '-' }}</td>
                      <!-- <td class="text-center">{{ invoice.date ? getDate(invoice.date) : '-' }}</td>-->
                      <!--                      <td class="text-center">{{ invoice.dueDate ? getDate(invoice.dueDate) : '-'}}</td>-->
                      <td class="text-left">
                        {{
                          invoice.currency ? new Intl.NumberFormat('en-ZA', {
                            style: 'currency',
                            currency: invoice.currency
                          }).format(invoice.total ? invoice.total / 100 : 0.00) : '-'
                        }}
                      </td>
                      <td class="text-left">
                        {{
                          invoice.currency ? new Intl.NumberFormat('en-ZA', {
                            style: 'currency',
                            currency: invoice.currency
                          }).format(invoice.balance ? invoice.balance / 100 : 0.00) : '-'
                        }}
                      </td>
                      <td col="Rate: " class="text-left">
                        {{ invoice.rate ? (invoice.rate / 100).toFixed(2) : '-' }}
                      </td>
                      <td class="text-left">{{ invoice.dateCreated ? utcDateToLocal(invoice.dateCreated) : '-' }}</td>
                      <td class="text-left">
                        <label v-if="invoice.invoiceStatus === 'DRAFT'" class="badge badge-secondary">DRAFT</label>
                        <label v-else-if="invoice.invoiceStatus === 'PARTIALLY_PAID'" class="badge text-white"
                               style="background-color: darkorange">PARTIAL</label>
                        <label v-else-if="invoice.invoiceStatus === 'PAID'" class="badge badge-success"
                               style="color: white">
                          <i style="display: none" class="fa fa-check-circle"></i> PAID
                        </label>
                        <label v-else-if="invoice.invoiceStatus === 'CANCELLED'" class="badge badge-warning"
                               style="color: white">
                          <i style="display: none" class="fa fa-times-circle"></i> CANCELLED
                        </label>
                        <label v-else-if="invoice.invoiceStatus === 'UNPAID'" class="badge badge-danger"
                               style="color: white">UNPAID</label>
                        <label v-else-if="invoice.invoiceStatus === 'OVERPAID'" class="badge badge-purple"
                               style="color: white">OVERPAID</label>
                        <label v-else class="badge badge-secondary">{{ invoice.invoiceStatus }}</label>
                      </td>
                      <td class="text-left" v-if="showSyncStatus">
                        <label v-if="invoice.syncStatus === 'PENDING'" class="badge badge-secondary">PENDING</label>
                        <label v-else-if="invoice.syncStatus === 'RE_SYNC'" class="badge badge-warning">RE-SYNC</label>
                        <label v-else-if="invoice.syncStatus === 'SYNCED'" class="badge badge-success"
                               style="color: white"><i class="fa fa-check-circle"></i> SYNCED</label>
                        <label v-else-if="invoice.syncStatus === 'FAILED'" class="badge badge-danger"
                               style="color: white"><i class="fa fa-times-circle"></i> FAILED</label>
                        <label v-else class="badge badge-secondary">{{ invoice.invoiceStatus }}</label>
                      </td>
                      <td class="text-right">
                        <a @click="viewInvoice(invoice.id)" class="btn btn-sm bg-info-light"><i
                          class="fa fa-eye mr-1"></i> View</a>
                        <!--                        <a @click="deleteInvoice(invoice.id)" class="btn btn-sm bg-danger-light"><i class="fa fa-trash mr-1"></i></a>-->
                        <!--                        <a @click="syncInvoice(invoice.id)" class="btn btn-sm bg-success-light"><i class="fa fa-sync mr-1"></i></a>-->
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="row" v-if="invoices.length">
                    <div class="col-sm-12 col-md-5">
                      <div class="" id="tblProducts_info" role="status" aria-live="polite" style="padding-top: 1.25em">
                        Show
                        <select @change="onChangeRecordsPerPage" v-model="recordsPerPage">
                          <option :value="12">12</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                        of {{ totalRecords }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers" id="tblProducts_paginate"
                           style="padding-top: 0.55em">
                        <pagination
                          :totalPages="totalPages"
                          :perPage="recordsPerPage"
                          :currentPage="currentPage"
                          @pagechanged="onPageChange"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="!invoices.length" class="text-center mt-5 mb-5">
                    <div v-if="!isLoading">You don't have any invoices yet</div>
                    <!--                    <div>-->
                    <!--                      <router-link to="/invoices/create" class="btn btn-info ml-3 mt-3">Create Invoice</router-link>-->
                    <!--                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import invoiceService from "../../service/invoice.service";
import process from "shelljs";
import Pagination from "../Pagination";
import {invoiceTabs, utcDateToLocal} from "../../utils/utils";
import InvoiceListTable from "../invoices/InvoiceListTable"
import {getConfig} from "../../utils/config";
import permissionService from "../../service/permission.service";
import GenericTabs from "../shared/GenericTabs";
import {handleError} from "../../utils/notification.utils";
import {allowedModules} from "../../utils/modules";
import {isCustomerContact as selectedContextIsCustomerContact} from "../../utils/customer.context";

export default {
  name: "list-invoices",
  title: process.env.SERVER_URI,
  components: {
    Pagination,
    InvoiceListTable,
    GenericTabs
  },
  data() {
    return {
      invoices: [],
      currentIndex: -1,
      title: "",
      searchValue: "",
      permissions: {},
      pagePermissions: ['INVOICE_CREATE', 'INVOICE_READ', 'INVOICE_UPDATE', 'INVOICE_DELETE', 'INVOICES_READ', 'INVOICES_SEARCH'],
      displayDisabledButtons: !getConfig().hideIfNoPermission,
      searchFilters: [
        {key: "customerName", value: "filters.customerName"},
        {key: "customerNumber", value: "filters.customerNumber"},
        {key: "customerEmail", value: "filters.customerEmail"},
        {key: "customerPhone", value: "filters.customerPhone"},
        {key: "invoiceNumber", value: "Invoice Number"},
        {key: "currency", value: "Currency"},
      ],
      selectedSearchFilterId: "customerName",
      showDeleteAllInvoicesButton: false,
      showSyncStatus: false,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 25,
      isLoading: false,
      activeTab: 'invoices',
      modules: [],
      invoiceTabs: [],
    };
  },
  methods: {
    utcDateToLocal: utcDateToLocal,
    syncInvoices() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      invoiceService.syncInvoices({})
        .then(response => {
          if (response.data.success === true) {
            this.retrieveInvoices()
            Swal.fire({
              icon: 'success',
              title: 'Synced',
              text: "Successfully synced invoices",
              footer: '<a href="">Why do I have this issue?</a>'
            })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Failed',
              text: response.data.narrative,
              footer: '<a href="">Why do I have this issue?</a>'
            })
          }
        })
        .catch(e => {
          handleError(e);
        })
        .finally(() => {
          loader.hide()
        })
    },
    pushInvoices() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      invoiceService.pushInvoices({})
        .then(response => {
          if (response.data.success === true) {
            this.retrieveInvoices()
            Swal.fire({
              icon: 'success',
              title: 'Synced',
              text: "Successfully synced invoices",
              footer: '<a href="">Why do I have this issue?</a>'
            })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Failed',
              text: response.data.narrative,
              footer: '<a href="">Why do I have this issue?</a>'
            })
          }
        })
        .catch(e => {
          handleError(e);
        })
        .finally(() => {
          loader.hide()
        })
    },
    searchInvoices(e) {
      if (e) {
        e.preventDefault();
      }
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      let params = {
        type: ["INVOICE", "CREDIT_NOTE", "DEBIT_NOTE"],
        page: this.currentPage,
        size: this.recordsPerPage,
        op: 'like',
        sortBy: 'dateCreated',
        sortOrder: 'DESC'
      }
      if (this.selectedSearchFilterId === 'statuses') {
        const statuses = ["Saab", "Volvo", "BMW"];
        params[this.selectedSearchFilterId] = statuses
      } else if (this.searchValue) {
        params[this.selectedSearchFilterId] = this.searchValue;
      }
      invoiceService.findDocs(params)
        .then(response => {
          console.log('searchInvoices response:', response.data);
          this.invoices = response.data.data || [];
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages || 0 : 0;
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords || 0 : 0;
        })
        .catch(e => {
          console.error('searchInvoices error:', e);
          handleError(e);
        })
        .finally(() => {
          loader.hide()
        })
    },
    fetchInvoices() {
      this.retrieveInvoices();
    },
    retrieveInvoices() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      this.isLoading = true
      let params = {
        type: ["INVOICE", "CREDIT_NOTE", "DEBIT_NOTE"],
        page: this.currentPage,
        size: this.recordsPerPage,
        op: 'like',
        sortBy: 'dateCreated',
        sortOrder: 'DESC'
      }
      // Only add search value if it's not empty
      if (this.searchValue) {
        params[this.selectedSearchFilterId] = this.searchValue;
      }
      invoiceService.findDocs(params)
        .then(response => {
          console.log('retrieveInvoices response:', response.data);
          this.invoices = response.data.data || [];
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages || 0 : 0;
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords || 0 : 0;
        })
        .catch(e => {
          console.error('retrieveInvoices error:', e);
          handleError(e);
        })
        .finally(() => {
          this.isLoading = false;
          loader.hide()
        })
    },
    changeSearchFilter() {
      this.fetchInvoices()
    },
    goToCreateInvoice() {
      this.$router.push(`/invoices/create`);
    },
    goToCreateBulkInvoice() {
      this.$router.push(`/billing/create`);
    },
    viewInvoice(id) {
      this.$router.push(`/invoices/${id}`);
    },
    syncInvoice(id) {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      invoiceService.syncInvoice(id)
        .then(response => {
          if (response.data.success === true) {
            Swal.fire({
              icon: 'success',
              title: 'Synced',
              text: "Successfully synced invoice",
              footer: '<a href="">Why do I have this issue?</a>'
            })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Failed',
              text: response.data.narrative,
              footer: '<a href="">Why do I have this issue?</a>'
            })
          }
        })
        .catch(e => {
          handleError(e);
        })
        .finally(() => {
          loader.hide()
        })
    },

    deleteInvoice(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show({
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel,
          });
          invoiceService.delete(id)
            .then(response => {
              if (response.data.success === true) {
                this.invoices = this.invoices.filter(function (item) {
                  return item.id !== id;
                });
                this.$router.push('/invoices');
                this.retrieveInvoices()
                Swal.fire({
                  icon: 'success',
                  title: 'Deleted',
                  text: "Successfully deleted invoice",
                  footer: '<a href="">Why do I have this issue?</a>'
                })
              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href="">Why do I have this issue?</a>'
                })
              }
            })
            .catch(e => {
              handleError(e);
            })
            .finally(() => {
              loader.hide()
            })
        }
      })
    },

    deleteInvoices() {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show({
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel,
          });
          invoiceService.deleteAll()
            .then(response => {
              if (response.data.success === true) {
                this.retrieveInvoices()
                this.invoices = this.invoices.filter(function (item) {
                  return item.id !== id;
                });
                Swal.fire({
                  icon: 'success',
                  title: 'Deleted',
                  text: "Successfully deleted invoices",
                  footer: '<a href="">Why do I have this issue?</a>'
                })
              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Failed!',
                  text: response.data.narrative,
                  footer: '<a href="">Why do I have this issue?</a>'
                })
              }
            })
            .catch(e => {
              handleError(e);
            })
            .finally(() => {
              loader.hide()
            })
        }
      })
    },
    getDate(stringDate) {
      const date = moment(stringDate);
      return date.format("DD-MM-YYYY")
    },
    fireNotification(icon, message, timeout) {
      Swal.fire({
        toast: true,
        width: 300,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: timeout,
        timerProgressBar: true,
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchInvoices()
    },
    onChangeRecordsPerPage() {
      this.fetchInvoices()
    },
    localStorageSpace() {
      const localStorageSpace = function () {
        let data = '';
        console.log('Current local storage: ');
        for (const key in window.localStorage) {
          if (window.localStorage.hasOwnProperty(key)) {
            data += window.localStorage[key];
            console.log(key + " = " + ((window.localStorage[key].length * 16) / (8 * 1024)).toFixed(2) + ' KB');
          }
        }
        console.log(data ? '\n' + 'Total space used: ' + ((data.length * 16) / (8 * 1024)).toFixed(2) + ' KB' : 'Empty (0 KB)');
        console.log(data ? 'Approx. space remaining: ' + (5120 - ((data.length * 16) / (8 * 1024)).toFixed(2)) + ' KB' : '5 MB');
      };
    },
    hasPermission(permission) {
      return this.permissions[permission]
    },
    showButtonFor(permission) {
      if (this.hasPermission(permission)) {
        return true
      } else {
        return this.displayDisabledButtons
      }
    },
    isDisabledFor(permission) {
      return !this.hasPermission(permission)
    },
    buttonTooltip(permission) {
      return this.isDisabledFor(permission) ? 'You do not have access to this feature' : ''
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isCustomerContact() {
      return selectedContextIsCustomerContact();
    }
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login')
      return
    }

    // Debug: Check if customer context exists
    const selectedContext = localStorage.getItem('selectedContext');
    if (selectedContext) {
      console.log('Customer context found:', JSON.parse(selectedContext));
    } else {
      console.error('No customer context found in localStorage!');
    }

    this.modules = allowedModules.filter(module => module.name === this.$i18n.locale)[0].modules;
    this.invoiceTabs = invoiceTabs.filter(invoiceTab => invoiceTab.industries.includes(this.$i18n.locale))

    this.fetchInvoices();
  }
}
</script>

<!--<style>-->
<!--.table {-->
<!--  display: block !important;-->
<!--  overflow-x: auto !important;-->
<!--  width: 100% !important;-->
<!--}-->
<!--</style>-->
<style scoped>
.bulk {
  cursor: pointer;
  color: #004A59;
}

.bulk :hover {
  background-color: #9fe870;
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed
}
</style>



// WEBPACK FOOTER //
// src/components/invoices/InvoiceList.vue